import { render } from "./DialogLogin.vue?vue&type=template&id=1ab4f6d2"
import script from "./DialogLogin.vue?vue&type=script&lang=js"
export * from "./DialogLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__